import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { searchResponse } from '../models/response';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { userConfig } from '../models/config';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  // api url key
  url:string = environment.apiUrl;

  // search text input
  searchInputText = new BehaviorSubject<string>("");
  // search results
  searchResults:string[] = [];

  constructor(private http:HttpClient) { }

  setSearchInputText(text:string){
    this.searchInputText.next(text);
  }

  searchProduct(queryText:string,sessionId: string, pageSize:number, pageToken:string, intialization:boolean, storeName:string | undefined, stateName:string | undefined,user: userConfig):Observable<searchResponse>{
      const body = {
        sessionId: sessionId,
        query: queryText, 
        pageSize: pageSize, 
        pageToken: pageToken,  
        init: intialization, 
        user: user,
        configs: {
            store: storeName, 
            state: stateName
        }
      }
      return this.http.post<searchResponse>(`${this.url}/ask-scotty/product-search`,body)
    }

    setSearchRecords(inputText:string){
      this.searchResults = [];
      const results = localStorage.getItem('results');
      if(results === null){
        this.searchResults = [inputText.toLowerCase().trim()];
      } else if (results && !results.split(',').includes(inputText.toLowerCase().trim())){
        this.searchResults = [inputText.toLowerCase().trim(), ...results.split(',')];
      } else {
        this.searchResults = [ ...results.split(',')];
      }
      if(this.searchResults.length > 5){
        this.searchResults.pop();
      }
      localStorage.setItem('results', this.searchResults.toString());
    }
}
